import { Component, Injectable, defineInjectable, NgModule } from '@angular/core';
import * as Highcharts from 'highcharts';
import { charts } from 'highcharts';
import funnel from 'highcharts/modules/funnel';
import item from 'highcharts/modules/item-series';
import timeline from 'highcharts/modules/timeline';
import { HighchartsChartModule } from 'highcharts-angular';
import { UtilsModule, LoggerService, ConsoleLoggerService } from 'utils';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// funnel(Highcharts);
var FunnelChartComponent = /** @class */ (function () {
    function FunnelChartComponent() {
        this.Highcharts = Highcharts;
        this.chartOptions = (/** @type {?} */ ({
            chart: {
                type: 'funnel'
            },
            title: { text: '' },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b> ({point.y:,.0f})',
                        softConnector: true
                    },
                    center: ['40%', '50%'],
                    neckWidth: '30%',
                    neckHeight: '25%',
                    width: '80%'
                }
            },
            legend: {
                enabled: false
            },
            series: [{
                    name: 'Unique users',
                    data: [
                        ['Website visits', 15654],
                        ['Downloads', 4064],
                        ['Requested price list', 1987],
                        ['Invoice sent', 976],
                        ['Finalized', 846]
                    ]
                }],
            responsive: {
                rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        inside: true
                                    },
                                    center: ['50%', '50%'],
                                    width: '100%'
                                }
                            }
                        }
                    }]
            }
        }));
        funnel(this.Highcharts);
    }
    /**
     * @return {?}
     */
    FunnelChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    FunnelChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'widget-funnel-chart',
                    template: "\n    <highcharts-chart\n      [Highcharts]=\"Highcharts\"\n      [options]=\"chartOptions\"\n      style=\"width: 100%; height: calc(100% - 40px); display: inline-block;\">\n    </highcharts-chart>\n  "
                }] }
    ];
    /** @nocollapse */
    FunnelChartComponent.ctorParameters = function () { return []; };
    return FunnelChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PieChartComponent = /** @class */ (function () {
    function PieChartComponent() {
        this.Highcharts = Highcharts;
        this.chartOptions = (/** @type {?} */ ({
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: { text: '' },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                        style: {
                        // color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                        // color: 'black'
                        }
                    }
                }
            },
            series: [{
                    name: 'Brands',
                    colorByPoint: true,
                    data: [{
                            name: 'Chrome',
                            y: 61.41,
                            sliced: true,
                            selected: true
                        }, {
                            name: 'Internet Explorer',
                            y: 11.84
                        }, {
                            name: 'Firefox',
                            y: 10.85
                        }, {
                            name: 'Edge',
                            y: 4.67
                        }, {
                            name: 'Safari',
                            y: 4.18
                        }, {
                            name: 'Sogou Explorer',
                            y: 1.64
                        }, {
                            name: 'Opera',
                            y: 1.6
                        }, {
                            name: 'QQ',
                            y: 1.2
                        }, {
                            name: 'Other',
                            y: 2.61
                        }]
                }]
        }));
    }
    /**
     * @return {?}
     */
    PieChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    PieChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'widget-pie-chart',
                    template: "\n    <highcharts-chart\n      [Highcharts]=\"Highcharts\"\n      [options]=\"chartOptions\"\n      style=\"width: 100%; height: calc(100% - 40px); display: inline-block;\">\n    </highcharts-chart>\n  "
                }] }
    ];
    /** @nocollapse */
    PieChartComponent.ctorParameters = function () { return []; };
    return PieChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// item(Highcharts);
var ParliamentChartComponent = /** @class */ (function () {
    function ParliamentChartComponent() {
        this.Highcharts = Highcharts;
        this.chartOptions = (/** @type {?} */ ({
            chart: {
                type: 'item'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            legend: {
                labelFormat: '{name} <span style="opacity: 0.4">{y}</span>'
            },
            series: [{
                    name: 'Representatives',
                    keys: ['name', 'y', 'color', 'label'],
                    data: [
                        ['The Left', 69, '#BE3075', 'DIE LINKE'],
                        ['Social Democratic Party', 153, '#EB001F', 'SPD'],
                        ['Alliance 90/The Greens', 67, '#64A12D', 'GRÜNE'],
                        ['Free Democratic Party', 80, '#FFED00', 'FDP'],
                        ['Christian Democratic Union', 200, '#000000', 'CDU'],
                        ['Christian Social Union in Bavaria', 46, '#008AC5', 'CSU'],
                        ['Alternative for Germany', 94, '#009EE0', 'AfD']
                    ],
                    dataLabels: {
                        enabled: true,
                        format: '{point.label}'
                    },
                    // Circular options
                    center: ['50%', '88%'],
                    size: '170%',
                    startAngle: -100,
                    endAngle: 100
                }]
        }));
        item(this.Highcharts);
    }
    /**
     * @return {?}
     */
    ParliamentChartComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    ParliamentChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'widget-parliament-chart',
                    template: "\n    <highcharts-chart\n      [Highcharts]=\"Highcharts\"\n      [options]=\"chartOptions\"\n      style=\"width: 100%; height: calc(100% - 40px); display: inline-block;\">\n    </highcharts-chart>\n  "
                }] }
    ];
    /** @nocollapse */
    ParliamentChartComponent.ctorParameters = function () { return []; };
    return ParliamentChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// timeline(Highcharts);
var TimelineComponent = /** @class */ (function () {
    function TimelineComponent() {
        this.Highcharts = Highcharts;
        this.chartOptions = (/** @type {?} */ ({
            chart: {
                type: 'timeline'
            },
            xAxis: {
                visible: false
            },
            yAxis: {
                visible: false
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            colors: [
                '#4185F3',
                '#427CDD',
                '#406AB2',
                '#3E5A8E',
                '#3B4A68',
                '#363C46'
            ],
            series: [{
                    data: [{
                            name: 'First dogs',
                            label: '1951: First dogs in space',
                            description: '22 July 1951 First dogs in space (Dezik and Tsygan) '
                        }, {
                            name: 'Sputnik 1',
                            label: '1957: First artificial satellite',
                            description: '4 October 1957 First artificial satellite. First signals from space.'
                        }, {
                            name: 'First human spaceflight',
                            label: '1961: First human spaceflight (Yuri Gagarin)',
                            description: 'First human spaceflight (Yuri Gagarin), and the first human-crewed orbital flight'
                        }, {
                            name: 'First human on the Moon',
                            label: '1969: First human on the Moon',
                            // tslint:disable-next-line:max-line-length
                            description: 'First human on the Moon, and first space launch from a celestial body other than the Earth. First sample return from the Moon'
                        }, {
                            name: 'First space station',
                            label: '1971: First space station',
                            // tslint:disable-next-line:max-line-length
                            description: 'Salyut 1 was the first space station of any kind, launched into low Earth orbit by the Soviet Union on April 19, 1971.'
                        }, {
                            name: 'Apollo–Soyuz Test Project',
                            label: '1975: First multinational manned mission',
                            // tslint:disable-next-line:max-line-length
                            description: 'The mission included both joint and separate scientific experiments, and provided useful engineering experience for future joint US–Russian space flights, such as the Shuttle–Mir Program and the International Space Station.'
                        }]
                }]
        }));
        timeline(this.Highcharts);
    }
    /**
     * @return {?}
     */
    TimelineComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    TimelineComponent.decorators = [
        { type: Component, args: [{
                    selector: 'widget-timeline',
                    template: "\n    <highcharts-chart\n      [Highcharts]=\"Highcharts\"\n      [options]=\"chartOptions\"\n      style=\"width: 100%; height: calc(100% - 40px); display: inline-block;\">\n    </highcharts-chart>\n  "
                }] }
    ];
    /** @nocollapse */
    TimelineComponent.ctorParameters = function () { return []; };
    return TimelineComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DashboardWidgetService = /** @class */ (function () {
    function DashboardWidgetService() {
    }
    /**
     * @return {?}
     */
    DashboardWidgetService.prototype.reflowWidgets = /**
     * @return {?}
     */
    function () {
        charts.forEach((/**
         * @param {?} chart
         * @return {?}
         */
        function (chart) {
            // ERROR TypeError: Cannot read property 'reflow' of undefined
            if (chart) {
                chart.reflow();
            }
        }));
    };
    DashboardWidgetService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DashboardWidgetService.ctorParameters = function () { return []; };
    /** @nocollapse */ DashboardWidgetService.ngInjectableDef = defineInjectable({ factory: function DashboardWidgetService_Factory() { return new DashboardWidgetService(); }, token: DashboardWidgetService, providedIn: "root" });
    return DashboardWidgetService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { AngularMaterialModule } from 'utils';
var DashboardWidgetsModule = /** @class */ (function () {
    function DashboardWidgetsModule(logger) {
        this.logger = logger;
        this.logger.info('Dashboard Widgets Module initialised');
    }
    DashboardWidgetsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        // AngularMaterialModule,
                        HighchartsChartModule,
                        UtilsModule
                    ],
                    declarations: [FunnelChartComponent, ParliamentChartComponent, PieChartComponent, TimelineComponent],
                    providers: [
                        { provide: LoggerService, useClass: ConsoleLoggerService }
                    ],
                    exports: [FunnelChartComponent, ParliamentChartComponent, PieChartComponent, TimelineComponent]
                },] }
    ];
    /** @nocollapse */
    DashboardWidgetsModule.ctorParameters = function () { return [
        { type: LoggerService }
    ]; };
    return DashboardWidgetsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DashboardWidgetService, DashboardWidgetsModule, FunnelChartComponent, ParliamentChartComponent, PieChartComponent, TimelineComponent };
//# sourceMappingURL=dashboard-widgets.js.map
